import React, { useEffect, useState } from "react";

// components
import { Card, CardBody, CardHeader, Row, Col, Button } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../helpers/message.js";
import { formateDate, formateDateandTime } from "../../helpers/formats.js";

// api
import boletimvistoria_api from "../../api/boletimvistoria_api.js";

// views
import VistoriaFicha from "./VistoriaFicha";

export default function VistoriaLista({ situacaoAnalise, setshowLoading, handleReturn }) {

    const [rowView, set_rowView] = useState(null);

    const [list_table, set_list_table] = React.useState([]);
    const loadList = () => {
        setshowLoading(true);
        if (situacaoAnalise == "Pedido de Vista")
            boletimvistoria_api.getListPedidoVista().then(result => handleReturnLoadList(result));
        else
            boletimvistoria_api.getListByDashboard(situacaoAnalise).then(result => handleReturnLoadList(result));
    }

    const handleReturnLoadList = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            set_list_table(result.data);
        }
    }

    useEffect(() => {
        loadList();
    }, [situacaoAnalise]);

    const handleView = (rowData) => {
        setshowLoading(true);
        boletimvistoria_api.getItem(rowData.boletimVistoria_Id).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_rowView(result.data);
            }
        });
    }

    const handleReturnFicha = (reload) => {
        set_rowView(null);
        if (reload)
            loadList();
    }

    return (
        <>
            <div className={rowView ? "d-none" : "content"}>
                <Row>
                    <Col md="6">
                        <Button color="default" onClick={() => handleReturn(true)}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <h4 className="titleCard">Lista de Vistorias</h4>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col lg="12" md="12" sm="12">
                                        <MaterialTable style={{ minHeight: "auto" }}
                                            title="Resultado da Pesquisa"
                                            columns={[
                                                { title: '', render: (rowData) => (<i className={"fas fa-circle " + (rowData.semaforoProximaAcao == 'Vermelho' ? "text-danger" : (rowData.semaforoProximaAcao == "Amarelo" ? "text-warning" : "text-success"))}></i>) },
                                                { title: 'Número do Boletim', field: 'numeroBoletim' },
                                                { title: 'Situação Análise', field: 'situacaoAnalise' },
                                                { title: 'Data Vistoria', field: 'dataVistoria', render: (rowData) => formateDate(rowData.dataVistoria) },
                                                { title: 'Última Atualização', render: (rowData) => formateDateandTime(rowData.dataUltimaAtualizacao) },
                                                { title: 'Concessionária', field: 'concessionaria' },
                                                { title: 'Agente Fiscalizador', field: 'usuarioFiscal_Nome' },
                                                { title: 'Formulário', field: 'formularioVistoria_Identificacao' }
                                            ]}
                                            data={list_table}
                                            isLoading={false}
                                            options={{
                                                ...table_style,
                                                filtering: false,
                                                exportButton: true
                                            }}
                                            actions={[
                                                {
                                                    icon: 'search',
                                                    tooltip: 'Visualizar Registro',
                                                    onClick: (event, rowData) => handleView(rowData)
                                                }
                                            ]}
                                            localization={table_translate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4 text-center">
                                    <Col lg="4" md="4" sm="4">
                                        <i className="fas fa-circle text-success"></i>
                                        <strong className="pl-2">Pendente</strong>
                                    </Col>
                                    <Col lg="4" md="4" sm="4">
                                        <i className="fas fa-circle text-warning"></i>
                                        <strong className="pl-2">Urgente</strong>
                                    </Col>
                                    <Col lg="4" md="4" sm="4">
                                        <i className="fas fa-circle text-danger"></i>
                                        <strong className="pl-2">Crítico</strong>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {rowView &&
                <VistoriaFicha
                    boletimVistoria={rowView}
                    setshowLoading={setshowLoading}
                    handleReturn={handleReturnFicha}
                />
            }
        </>

    );
}